import { useContext } from "react";
import Tab from "../../contexts/Tab/Tab";

const NotFound = () => {
  const { currentTab } = useContext(Tab);
  return <div className="not-found">Failed to find page: {currentTab}</div>;
};

export default NotFound;
